import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const SHOOTING_RESULTS_REQUEST = 'FETCH_SHOOTING_RESULTS_REQUEST';
export const SHOOTING_RESULTS_FAILURE = 'FETCH_SHOOTING_RESULTS_FAILURE';
export const SHOOTING_RESULTS_SUCCESS = 'FETCH_SHOOTING_RESULTS_SUCCESS';

export const fetchShootingResults = (competitionId) => {
    return function(dispatch) {
        dispatch({ type: SHOOTING_RESULTS_REQUEST, competitionId });
        return axios(apiRequestOptions(apiPath.SHOOTING_RESULTS.LIST, { competition: competitionId }))
            .then(transformHttpResponse)
            .then(response => dispatch({ type: SHOOTING_RESULTS_SUCCESS, data: response.data, competitionId }))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: SHOOTING_RESULTS_FAILURE, competitionId });
                dispatch(errorRequestHandler(error));
            });
    }
};
